<template>
  <v-container v-if="aulaToUpdate">
    <v-row>
      <v-col cols="12">
        <v-btn text class="ui-back-btn" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
      <v-col cols="12" lg="5" offset-lg="4">
        <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Editar aula</v-card-title>
          <v-card-text>
            <v-form v-model="classroomForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      class="ui-form-field"
                      v-model="aulaToUpdate.aula"
                      rounded
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Nombre del aula"
                      :rules="nameRules"
                    >
                      <template v-slot:label>Nombre del aula <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      class="ui-form-field"
                      v-model="aulaToUpdate.ubicacion"
                      rounded
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      :rules="nameRules"
                    >
                      <template v-slot:label>Ubicación <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      class="ui-form-field"
                      v-model.number="aulaToUpdate.capacidad"
                      type="number"
                      rounded
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Capacidad"
                      :rules="nameRules"
                    >
                      <template v-slot:label>Capacidad <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      class="ui-form-field"
                      background-color="transparent"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="classroomStatus"
                      item-value="id"
                      item-text="title"
                      v-model="aulaToUpdate.fkidEstatusAula"
                    >
                      <template v-slot:label>Estatus del aula <span class="red--text">*</span> </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center ui-module-actions">
            <v-btn
              color="secondary"
              class="mb-8 ui-module-btn-solid"
              :disabled="!classroomForm"
              v-on:click="triggerSaveClassroom()"
              >Editar aula</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_AULA_TO_UPDATE(this.id)
  },

  data() {
    return {
      classroomForm: false,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('estatusAula', {
      classroomStatus: 'getClassroomStatus',
    }),

    ...mapGetters('aula', {
      aulaToUpdate: 'getAulaToUpdate',
    }),
  },

  methods: {
    ...mapActions('aula', ['updateAula', 'fetchAulas']),
    ...mapMutations('aula', ['SET_AULA_TO_UPDATE']),

    triggerSaveClassroom: async function () {
      this.loading = true

      await this.updateAula(this.aulaToUpdate)
      await this.fetchAulas()
      this.$router.replace('/profesionalizacion/aulas')

      this.loading = false
    },
  },
}
</script>

<style scoped>
.ui-back-btn {
  color: #26de81 !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #26de81 !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #062118 !important;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.28) !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 210, 160, 0.25) !important;
}

.red--text {
  color: #ff5252 !important;
}
</style>
